// directives/hide.js
export const hide = {
    selector: '[data-hide]',
    reactive: true,
    run(el, data, root) { 
    }
};